import {Component, computed, inject} from '@angular/core';
import {FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {environment} from '@environments/environment';
import {
  HeartHandshakeIcon,
  LandmarkIcon,
  LucideAngularModule,
  MegaphoneIcon,
  SearchIcon,
  UsersIcon
} from 'lucide-angular';
import {RouteGenerator} from '@core/route-generator';
import {
  ActivitySearchService
} from '@public/activity/search-activity/components/activity-search-filters/activity-search.service';
import {PlaceDTO, PlaceRank} from '@domain/place/place.dto';
import {UI_ROUTES} from '@core/ui.routes';
import {PlaceFieldComponent} from '@domain/place/component/form/place-field/place-field.component';
import {toSignal} from '@angular/core/rxjs-interop';
import {PlaceUtil} from '@domain/place/place.util';

@Component({
  selector: 'app-public-dashboard',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink,
    LucideAngularModule,
    PlaceFieldComponent
  ],
  templateUrl: './public-dashboard.component.html',
  styleUrl: './public-dashboard.component.scss'
})
export class PublicDashboardComponent {

  private readonly route = inject(ActivatedRoute);
  private readonly data = toSignal(this.route.data);
  protected readonly region = computed(() => this.data()?.region as PlaceDTO);
  protected readonly districts = computed(() => (this.region()?.children ?? []) as PlaceDTO[]);

  public readonly appName = environment.appName;
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly searchService = inject(ActivitySearchService);
  public readonly searchForm = this.fb.group({
    place: this.fb.control<PlaceDTO | null>(null)
  });

  public readonly townRank = PlaceRank.Town;

  public readonly icons = {
    search: SearchIcon,
    publish: MegaphoneIcon,
    public: LandmarkIcon,
    open: UsersIcon,
    people: HeartHandshakeIcon
  };

  public readonly routes = {
    search: RouteGenerator.abs(UI_ROUTES.public.activity.search),
    publish: RouteGenerator.abs(UI_ROUTES.public.activity.publish),
    faq: RouteGenerator.abs(UI_ROUTES.public.faq),
    partners: RouteGenerator.abs(UI_ROUTES.public.partners)
  };
  public readonly year = new Date().getFullYear();

  public showPlaceRequired = false;

  public search(): void {
    const town = this.searchForm.value.place;
    if (town?.code) {
      this.showPlaceRequired = false;
      this.searchService.resetSearch();
      this.router.navigate(
        [this.routes.search],
        {
          queryParams: {
            [ActivitySearchService.QUERY_TOWN_CODE]: town?.code
          }
        }
      ).then(_ok =>  {});
    } else {
      this.showPlaceRequired = true;
    }
  }

  public getPlaceUrl(place: PlaceDTO): string {
    const slug = PlaceUtil.getSlug(place, this.region())!;
    return RouteGenerator.abs(UI_ROUTES.public.place.home, {slug: slug});
  }

}
